<style lang='less' scoped>
@import '../base.less';

</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isXg' clearable
                                                      :placeholder="$t('港澳') " style='width:120px'>
              <Option :value="'0'">{{ $t('新澳门') }}</Option>
              <Option :value="'1'">{{ $t('香港') }}</Option>
              <Option :value="'2'">{{ $t('老澳门') }}</Option>
              <Option :value="'3'" >{{ $t('新加坡') }}</Option>
              <Option :value="'4'" >{{ $t('柬埔寨') }}</Option>
              <Option :value="'5'" >{{ $t('台湾') }}</Option>
              <Option :value="'6'" >{{ $t('印尼') }}</Option>
              <Option :value="'7'" >{{ $t('马来西亚') }}</Option>
            </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.lastResult'
                                                      :placeholder="$t('连中/连错') " style='width:120px'>
              <Option :value="1">{{ $t('连中1次') }}</Option>
              <Option :value="2">{{ $t('连中2次') }}</Option>
              <Option :value="3">{{ $t('连中3次') }}</Option>
              <Option :value="4">{{ $t('连中4次') }}</Option>
              <Option :value="-1">{{ $t('连错1次') }}</Option>
              <Option :value="-2">{{ $t('连错2次') }}</Option>
              <Option :value="-3">{{ $t('连错3次') }}</Option>
              <Option :value="-4">{{ $t('连错4次') }}</Option>
            </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.changeType'
                                                      :placeholder="$t('换帖类型') " style='width:120px'>
              <Option :value="0">{{ $t('默认') }}</Option>
              <Option :value="1">{{ $t('自动') }}</Option>
              <Option :value="2">{{ $t('手动') }}</Option>
            </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.indexTitle' :placeholder="$t('首页大标题') "></Input>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.filename' :placeholder="$t('文件名') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.category' clearable
                      :placeholder="$t('分类') " style='width:120px'>

                <Option :key="key" :value="value"
                        v-for="(value, key) in AllCategoryParams"> {{ value }}
                </Option>
              </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.playWeight'
                                                      :placeholder="$t('权重') " style='width:120px'>
              <Option :value="10">{{ $t('10') }}</Option>
              <Option :value="9">{{ $t('9') }}</Option>
              <Option :value="8">{{ $t('8') }}</Option>
              <Option :value="7">{{ $t('7') }}</Option>
              <Option :value="6">{{ $t('6') }}</Option>
              <Option :value="5">{{ $t('5') }}</Option>
              <Option :value="4">{{ $t('4') }}</Option>
              <Option :value="3">{{ $t('3') }}</Option>
              <Option :value="2">{{ $t('2') }}</Option>
              <Option :value="1">{{ $t('1') }}</Option>

            </Select>
            </FormItem>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
            <Button type='error'  @click='inAll' icon='md-add'>{{
                $t('一键排帖')
              }}
            </Button>
            <Button type='warning'  @click='inALL2' icon='md-add'>{{
                $t('分类排贴')
              }}
            </Button>
            <Button type='info'  @click='out' icon='md-add'>{{
                $t('导出')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!--    添加窗口-->
    <Modal v-model="windowAddX.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddXCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('添加（帖子详细内容请添加后再去编辑）') }}</span>
      </p>
      <Form ref="windowAddXForm" :model="windowAddXItem" label-position="left"
            :label-width="80">

        <FormItem label='港澳' prop='isXg'>
          <Select clearable v-model='windowAddXItem.isXg' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('新澳门') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('香港') }}</Option>
            <Option :value="'2'" :key='2'>{{ $t('老澳门') }}</Option>
            <Option :value="'3'" :key='3'>{{ $t('新加坡') }}</Option>
            <Option :value="'4'" :key='4'>{{ $t('柬埔寨') }}</Option>
            <Option :value="'5'" :key='5'>{{ $t('台湾') }}</Option>
            <Option :value="'6'" :key='6'>{{ $t('印尼') }}</Option>
            <Option :value="'7'" :key='7'>{{ $t('马来西亚') }}</Option>
          </Select>
        </FormItem>

        <FormItem label='文件名'>
          <Input v-model="windowAddXItem['filename']" :placeholder="$t('请输入文件名')"
                 style="width: 200px;"></Input>
        </FormItem>

        <FormItem label='文件储存目录'>
          <Input v-model="windowAddXItem['path']" :placeholder="$t('请输入文件储存目录')"
                 style="width: 200px;"></Input>
        </FormItem>

        <FormItem label='排序'>
          <Input v-model="windowAddXItem['order']" :placeholder="$t('请输入排序序号')"
                 style="width: 200px;"></Input>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="text" @click="windowAddXCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddXSubmit" :loading="windowAddX.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>

    <!-- 编辑窗口 -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('编辑') }}</span>
      </p>

      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('(如果是人工内容,将仅展示页面广告部分,自动生成的数据不展示,请人工填充内容)') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" label-position="left"
            :label-width="80">


        <FormItem label='首页大标题'>
          <Input v-model="extraParams['indexTitle']" :placeholder="$t('请输入标题,请根据玩法填写')" :disabled="windowAddItem.id"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='分类/玩法' prop='categorySuper'>

          <Cascader :data="categorySuperParams" v-model="extraParams['categorySuper']" @on-change="selectWf"
                    style='position: absolute; width:200px' filterable clearable/>
          <Button style="margin-left: 210px" type="error" @click="getParams(extraParams['id'],'wf')">{{
              $t('一键生成高准确率内容')
            }}
          </Button>
            <Button style="margin-left: 210px" type="error" @click="getParams(extraParams['id'],'wft')">{{
                $t('一键生成同类型高准确率内容')
              }}
          </Button>

        </FormItem>

        <FormItem label='小标题'>
          <Input v-model="extraParams['title']" :placeholder="$t('请输入标题,请根据玩法填写')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
          <Button type="info" @click="getParams(extraParams['id'],'title')" class="margin-left-10">{{
              $t('使用默认标题')
            }}
          </Button>
        </FormItem>

        <FormItem label='作者'>
          <Input v-model="extraParams['author']" :placeholder="$t('请输入作者')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
          <Button type="info" @click="getParams(extraParams['id'],'author')" class="margin-left-10">{{
              $t('随机一个')
            }}
          </Button>
        </FormItem>


        <FormItem label='签名'>
          <Input v-model="extraParams['signature']" :placeholder="$t('请输入签名')" :disabled="windowAddItem.id"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='保留最近几期(不填为都保留)'>
          <Input v-model="extraParams['baoliuIssues']" :placeholder="$t('保留最近几期,最小值为10')" :disabled="windowAddItem.id"
                 style="width: 500px;"></Input>
        </FormItem>


        <p :prop="key" v-for="(value, key) in extraParams['fieldData']">
          <FormItem :label="value['issue']+'期'">
            <Input v-model="value['code']" :placeholder="$t('购买号码')" :disabled="windowAddItem.id"
                   style="width: 200px;"></Input>
            <Button type="info" @click="getParams(extraParams['id'],value['issue'])" class="margin-left-10">{{
                $t('随机一个')
              }}
            </Button>



            <span style="margin-left: 15px ;color: red" v-if="value['opened']===false">{{   value['opened'] + value['isZhun']+ ' (开'+value['open']+')' }}</span>
            <span style="margin-left: 15px ;color: blue"v-if="value['opened']!==false">{{   value['opened'] + value['isZhun']+ ' (开'+value['open']+')' }}</span>

            <Select  clearable v-model="value['isShow']"
                     :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
              <Option :value="1">{{ $t('显示') }}</Option>
              <Option :value="0" >{{ $t('不显示') }}</Option>
            </Select>

            <Input v-model="value['smallTip']" :placeholder="$t('提醒')" :disabled="windowAddItem.id"
                   style="width: 200px;"></Input>
          </FormItem>
        </p>

        <FormItem label='加粉贴内容(不设置请留空)'>
          <Input v-model="extraParams['jiafen']" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')" :disabled="windowAddItem.id"
                 style="width: 500px;"></Input>
        </FormItem>

        <div v-html="extraParams['tem']"></div>
        <br>
        <FormItem label='指定自动换贴备选更换的玩法'>
          <Input v-model="extraParams['autoChangeFields']" :placeholder="$t('请输入ID,以逗号隔开 如: 1,2,3(如果指定的玩法都被使用,则全随机)')" :disabled="windowAddItem.id"
                 ></Input>
        </FormItem>
        <FormItem label='文件名'>
          <Input v-model="extraParams['filename']" :placeholder="$t('请输入文件名')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
        </FormItem>
        <FormItem label='文件储存目录'>
          <Input v-model="extraParams['path']" :placeholder="$t('请输入文件储存目录')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
        </FormItem>

        <FormItem label='排序'>
          <Input v-model="extraParams['order']" :placeholder="$t('请输入排序序号')" :disabled="windowAddItem.id"
                 style="width: 200px;"></Input>
        </FormItem>
        <FormItem label='锁定时达到几期也更换'>

          <InputNumber :max="10" :min="1" :step="1" v-model="extraParams.maxErrorToChangeWhenLock" />
        </FormItem>
        <FormItem label='评级'>
          <Input  v-model="extraParams.pingji" />
        </FormItem>

        <FormItem label='预测中的文字'>
          <Select clearable v-model="extraParams['zhunText']" style='width:200px'>
            <Option :key="value" :value="value"
                    v-for="(value, key) in trueTextArray"> {{ value }}
            </Option>

<!--            <Option :value="'准'" :key="'准'">{{ $t('准') }}</Option>-->
<!--            <Option :value="'对'" :key="'对'">{{ $t('对') }}</Option>-->
<!--            <Option :value="'中'" :key="'中'">{{ $t('中') }}</Option>-->
<!--            <Option :value="'正确'" :key="'正确'">{{ $t('正确') }}</Option>-->
<!--            <Option :value="'准确'" :key="'准确'">{{ $t('准确') }}</Option>-->
<!--            <Option :value="'√'" :key="'√'">{{ $t('√') }}</Option>-->
<!--            <Option :value="'漂亮'" :key="'漂亮'">{{ $t('漂亮') }}</Option>-->
<!--            <Option :value="'给力'" :key="'给力'">{{ $t('给力') }}</Option>-->
          </Select>
        </FormItem>

        <FormItem label='贴子字体'>
          <Select clearable v-model="extraParams['BbsFont']" style='width:200px'>
            <Option :key="value" :value="value"
                    v-for="(value, key) in bbsFontArray"> {{ value }}
            </Option>

            <!--            <Option :value="'准'" :key="'准'">{{ $t('准') }}</Option>-->
            <!--            <Option :value="'对'" :key="'对'">{{ $t('对') }}</Option>-->
            <!--            <Option :value="'中'" :key="'中'">{{ $t('中') }}</Option>-->
            <!--            <Option :value="'正确'" :key="'正确'">{{ $t('正确') }}</Option>-->
            <!--            <Option :value="'准确'" :key="'准确'">{{ $t('准确') }}</Option>-->
            <!--            <Option :value="'√'" :key="'√'">{{ $t('√') }}</Option>-->
            <!--            <Option :value="'漂亮'" :key="'漂亮'">{{ $t('漂亮') }}</Option>-->
            <!--            <Option :value="'给力'" :key="'给力'">{{ $t('给力') }}</Option>-->
          </Select>
        </FormItem>

        <br>

        <FormItem style="margin-bottom:4px" label='页面广告' prop='body'>

<!--          <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{-->
<!--              $t('编辑源码')-->
<!--            }}-->
<!--          </Button>-->

<!--          <div v-if="isHtml==false" style="border: 1px solid #ccc;">-->
<!--            <Toolbar-->
<!--              style="border-bottom: 1px solid #ccc"-->
<!--              :editor="editor"-->
<!--              :defaultConfig="toolbarConfig"-->
<!--              :mode="mode"-->
<!--            />-->
<!--            <Editor-->
<!--              style="height: 200px; overflow-y: hidden;"-->
<!--              v-model="extraParams['ad1']"-->
<!--              :defaultConfig="editorConfig"-->
<!--              :mode="mode"-->
<!--              @onCreated="onCreated"-->
<!--            />-->
<!--          </div>-->
          <textarea  v-model="extraParams['ad1']" name="ckeditor" rows="10" cols="80"></textarea>
          <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

    <!-- windowAddEdit -->
    <Modal v-model="windowPL.show" width="728" :styles="{top: '30px'}" @on-visible-change="windowPLCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('编辑')  }}</span>
      </p>
      <Form ref="windowPLForm" :model="windowPLItem" :label-width="80"
            label-position="left">
        <FormItem :label='tip' prop='content'>
          <textarea v-model="windowPLItem.content"  rows="10" cols="80"></textarea>
        </FormItem>

      </Form>
      <div slot="footer" >
        <Button type="text" @click="windowPLCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowPLSubmit" :loading="windowPL.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

  </div>
</template>
<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'


import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

import {baseUrl} from '@/libs/api.request'
import CKEDITOR from 'CKEDITOR'
import {getToken,
  localSave,
  localRead} from '@/libs/util'

export default {
  name: 'interface_list',
  components: {Editor, Toolbar},

  data() {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {'Api-Auth': getToken()},

      editor: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...',
        MENU_CONF: {} },
      mode: 'default', // or 'simple',
      isHtml: true,

      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('序号'),
        type: 'index',
        width: 40,
        minWidth: 40,
        align: 'center'
      },{
        title: this.$t('ID号'),
        width:40,
        minWidth: 40,
        key: 'id',
        align: 'center'
      }, {
        title: this.$t('港澳'),
        align: 'center',
        width: 110,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.isXg != 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.isXg != 0 ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            },this.getGameName(params.row.isXg) ),
            h('br'),
            h('span', {
              style: {
                color: '#8f8d98' ,
                borderRadius: '11px',
                // border: '1px solid #3114ed',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, "文件名:"+params.row.filename)])
        }
      }, {
        title: this.$t('首页标题'),
        key: 'indexTitle',
        width: 140,
        minWidth: 140,
        align: 'center'
      },{
        title: this.$t('预测情况'),
        align: 'center',
        width: 125,
        minWidth: 125,
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.lastResult < 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.lastResult < 0 ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, (params.row.lastResult > 0 ? '连中' : '连错') + Math.abs(params.row.lastResult) + '|'+"共错"+(params.row.errorTimes)),
            h('br'),
            h('span', {
              style: {
                color: '#3114ed' ,
                borderRadius: '11px',
                // border: '1px solid #3114ed',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, "更新于"+params.row.updated_at.substr(5,11)),],)
        }
      },{
        title: this.$t('操作'),
        align: 'center',
        minWidth: 100,
        width: 100,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                this.getParams(params.row.id);
              }
            }
          }, this.$t('编辑资料')),  h('br'), h('Button', {
            props: {
              type: 'error'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                customPost('Lhc/bbsDataYuLan', {id:params.row.id}).then(response => {
                  window.open(response.data.data.tempUrl , '_blank')
                })
              }
            }
          }, this.$t('预览效果')),  h('br'), h('Button', {
            props: {
              type: 'info'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                  this.makeBbs(params.row.id)
              }
            }
          }, this.$t('生成页面'))])
        }
      },{
        title: this.$t('分类/权重'),
        align: 'center',
        width: 100,
        minWidth: 100,
        key: 'category',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: '#070707' ,
                borderRadius: '11px',
                // border:'1px solid #ed4014' ,
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.category),
            h('br'),
            h('span', {
              style: {
                color: '#858484' ,
                borderRadius: '11px',
                // border: '1px solid #3114ed',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, "权重:"+params.row.playWeight)],)
        }
      }, {
        title: this.$t('换贴类型'),
        align: 'center',
        sortable: true,
        width: 50,
        key: 'changeType',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.changeType != 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.changeType != 0 ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.changeType == 0 ? this.$t('默认') : (params.row.changeType == 1?this.$t('自动'):this.$t('手动'))),
          ])
        }
      },{
        title: '排序',
        sortable: true,
        key: 'order',
        align: 'center',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.order,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/bbsDataUpdateOrCreate', {id:params.row.id,order:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },{
        title: '人工内容',
        sortable: true,
        align: 'center',
        key:'isByHand',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isByHand,
            },
            on: {
              'on-change': function (status) {
                let vm = this
                customPost('Lhc/bbsDataUpdateOrCreate', {id:params.row.id,isByHand:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "人工"),
            h('span', {
              slot: 'close'
            }, "自动")
          ])
        }
      },{
        title: '自动更换锁定',
        sortable: true,
        align: 'center',
        key: 'isAutoChangeLock',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isAutoChangeLock,
            },
            on: {
              'on-change': function (status) {
               let vm = this
               customPost('Lhc/bbsDataUpdateOrCreate', {id:params.row.id,isAutoChangeLock:status}).then(response => {
                 vm.$Message.success(response.data.msg)
                 vm.getList()
               }).catch(() => {

               })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "锁定"),
            h('span', {
              slot: 'close'
            }, "正常")
          ])
        }
      }, {
        title: this.$t('锁定时连错几期也自动换'),
        key: 'maxErrorToChangeWhenLock',
        width:60,
        minWidth: 60,
        align: 'center'
      },{
        title: '优先换同类',
        sortable: true,
        align: 'center',
        key: 'isChangeSameCategory',
        width: 88,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isChangeSameCategory,
            },
            on: {
              'on-change': function (status) {
               let vm = this
               customPost('Lhc/bbsDataUpdateOrCreate', {id:params.row.id,isChangeSameCategory:status}).then(response => {
                 vm.$Message.success(response.data.msg)
                 vm.getList()
               }).catch(() => {
                 vm.windowAdd.loading = false
               })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "同类"),
            h('span', {
              slot: 'close'
            }, "随机")
          ])
        }
      },{
        title: this.$t('操作'),
        align: 'center',
        minWidth: 100,
        width: 100,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('Lhc/bbsDataDel', {id:params.row.id}).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      }],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 150,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      flParams: [],
      trueTextArray:[],
      bbsFontArray:[],
      categorySuperParams: [],
      extraParams: {id: 0},
      AllCategoryParams: {id: 0},
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        config_user: '',
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
      },
      windowAddValidate: {//窗口校验规则
      },
      //----------------
      windowAddX: { //弹窗
        show: false,
        loading: false,
        index: 0,
        config_user: '',
      },
      windowAddXItem: { //弹窗数据绑定
        id: 0,
      },
      windowAddXValidate: {//窗口校验规则
      },
      //弹窗--------------
      windowPL: { //弹窗
        show: false,
        loading: false,
        index: 0,
        isOut:false
      },

      windowPLItem: { //弹窗数据绑定
        id: 0
      },
      windowPLValidate: {//窗口校验规则
      },                            //----------------
      tip:""
    }
  },
  created() {
    // 自定义上传图片
    let that  = this
    that.editorConfig.MENU_CONF['uploadImage'] = {
      server: baseUrl + 'Index/upload',//上传接口地址
      headers: {
        Authorization:'Bearer '+getToken()//配置token
      },
      fieldName: 'file',//上传文件名
      customInsert( result, insertFn) {
        // result是返回的json格式
        // 从 result 中找到 url alt href ，然后插图图片
        console.log(result.data)
         insertFn(result.data['showUrl'],result.data['fileName'],result.data['showUrl'])
      }

    }



    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcAmBBSZhiliao/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcAmBBSZhiliao/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcAmBBSZhiliao/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })

    if(localRead('isXg')=='0' || localRead('isXg')=='1'){
      this.searchConf.isXg=localRead('isXg')
    }else{
      this.searchConf.isXg='0';
    }

  },
  mounted() {
    this.initializeEditor(),
    customPost('Lhc/getCategoryOption', {}).then(response => {
      this.categorySuperParams = response.data.data
    })
    customPost('Lhc/urlGet', {}).then(response => {
      this.trueTextArray = response.data.data.trueTextArray
      this.bbsFontArray=response.data.data.bbsFontArray
    })

    customPost('Lhc/fieldGetAllCategory',{}).then(response => {
      this.AllCategoryParams = response.data.data
    })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    initializeEditor () {
      this.editorObj1 = CKEDITOR.replace('ckeditor', {
        language: 'zh-CN',      // Adding drag and drop image upload.
        removeDialogTabs: 'image:advanced;image:Link',
        image_previewText: '  ',
        extraPlugins: 'uploadimage',
        uploadUrl: this.uploadUrlCk,
        filebrowserImageUploadUrl: this.uploadUrlCk,
        filebrowserUploadUrl: this.uploadUrlCk, //服务器上传地址
        removeButtons: 'Save,PasteFromWord,PasteText,Paste,Copy,Replace,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BulletedList,NumberedList,Indent,Outdent,Language,About,ShowBlocks,Flash,Anchor,HorizontalRule,PageBreak,Iframe'
      })

      // 图片上传返回的数据处理
      this.editorObj1.on('fileUploadResponse', function (evt) {
        evt.stop()
        var data = evt.data
        let xhr = data.fileLoader.xhr
        let response = xhr.responseText
        let imgUrl = JSON.parse(response).data.fileUrl
        if (!imgUrl) {
          data.message = '上传出错'   // 这是失败alert提示信息
          evt.cancel()
        } else {
          data.url = imgUrl   // 返回到“图像信息”那里的URL框里面
        }
      })
    },
    getGameName(isXg){
      if(isXg==0){
        return "新澳门";
      }else  if(isXg==1){
        return "香港";
      }else  if(isXg==2){
        return "老澳门";
      }else  if(isXg==3){
        return "新加坡";
      }else  if(isXg==4){
        return "柬埔寨";
      }else  if(isXg==5){
        return "台湾";
      }else  if(isXg==6){
        return "印尼";
      }else  if(isXg==7){
        return "马来西亚";
      }
      return ""
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    out(){
      if(this.searchConf.isXg!=null){
      window.open(baseUrl+'Lhc/getBbsCsv?isXg='+this.searchConf.isXg , '_blank')
      }else{
        this.$Message.error("请选择选定香港或澳门类型")
      }
    },
    makeBbs(id){
      customPost('Lhc/makeBbsDetail', {'id': id}).then(response => {
        this.$Message.success(response.data.msg)
      })
    },
    inAll() {
      let vm = this
      vm.tip="按照导出的格式复制进来（ID在前）"
      vm.windowPLItem.sortType=1;
      vm.windowPL.isOut=true
      vm.windowPL.show = true
      // customPost('Lhc/bbsResort', {}).then(response => {
      //   vm.windowPLItem=response.data.data
      //   vm.windowPL.show = true
      // })

    },
    inALL2(){
      let vm = this
      vm.tip="按照分类顺序排贴（仅复制分类，需要换行）"
      vm.windowPLItem.sortType=2;
      vm.windowPLItem.isXg=vm.searchConf.isXg;
      vm.windowPL.isOut=true

      customPost('Lhc/urlGet', {'id': 1}).then(response => {
        if(vm.searchConf.isXg=='1'){
          vm.windowPLItem.content=response.data.data.categorySort_1;
        }else  if(vm.searchConf.isXg=='0'){
          vm.windowPLItem.content=response.data.data.categorySort_0;
        }else  if(vm.searchConf.isXg=='2'){
          vm.windowPLItem.content=response.data.data.categorySort_2;
        }else  if(vm.searchConf.isXg=='3'){
          vm.windowPLItem.content=response.data.data.categorySort_3;
        }else  if(vm.searchConf.isXg=='4'){
          vm.windowPLItem.content=response.data.data.categorySort_4;
        }else  if(vm.searchConf.isXg=='5'){
          vm.windowPLItem.content=response.data.data.categorySort_5;
        }else  if(vm.searchConf.isXg=='6'){
          vm.windowPLItem.content=response.data.data.categorySort_6;
        }else  if(vm.searchConf.isXg=='7'){
          vm.windowPLItem.content=response.data.data.categorySort_7;
        }
        vm.windowPL.show = true
      });
    },
    preAdd() {
      this.windowAddX.show = true
    },
    getParams(id, key = '') {
      let vm = this
      if (key == '') {//新点击的时候
        this.isHtml = true;
        customPost('Lhc/getCategoryOption', {'id': id}).then(response => {
          this.categorySuperParams = response.data.data

          customPost('Lhc/bbsDataUpdateOrCreateSuper', {'id': id}).then(response => {
            this.extraParams = response.data.data
            this.editorObj1.setData(this.extraParams['ad1'])
            vm.windowAdd.show = true
          })
        })


      } else {
        //如果是变化,则把所有数据带过去
        this.extraParams.id = id;
        this.extraParams.key = key;
        customPost('Lhc/bbsDataUpdateOrCreateSuper', this.extraParams).then(response => {
          this.extraParams = response.data.data
          this.editorObj1.setData(this.extraParams['ad1'])
          vm.windowAdd.show = true
        })
      }
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page = vm.tableShow.currentPage
      vm.searchConf.size = vm.tableShow.pageSize

      if(vm.searchConf.isXg == '0' || vm.searchConf.isXg=='1'){
        localSave('isXg',  vm.searchConf.isXg)
      }


      customPost('Lhc/bbsDataGetList', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      this.extraParams.isSave = 1;
      this.extraParams.key = '';
      this.extraParams['ad1']=this.editorObj1.getData()

      customPost('Lhc/bbsDataUpdateOrCreateSuper', this.extraParams).then(response => {
        this.extraParams.isSave = 0;
        this.$Message.success(response.data.msg)
        this.windowAddCancel()
        this.getList();
      })

    },

    windowAddXCancel(data) {
      if (!data) {
        this.windowAddXItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAddX.show = false
        this.windowAddX.loading = false
        this.windowAddX.index = 0
      }
    }, windowAddXSubmit() {
      let vm = this
      customPost('Lhc/bbsDataUpdateOrCreate', vm.windowAddXItem).then(response => {
        vm.$Message.success(response.data.msg)
        vm.getList()
        vm.windowAddXCancel()
      }).catch(() => {
        vm.windowAdd.loading = false
      })
    },
    selectWf(param) {
      this.extraParams['field_id'] = param[1];
      this.getParams(this.extraParams['id'], "wf|" + param[1]);
    },
    windowPLCancel(data) {
      if (!data) {
        this.windowPLItem.id = 0
        this.$refs['windowPLForm'].resetFields()
        this.windowPL.show = false
        this.windowPL.loading = false
        this.windowPL.index = 0
      }
    }, windowPLSubmit() {
      let vm = this
      vm.$refs['windowPLForm'].validate((valid) => {
        if (valid) {
          vm.windowPL.loading = true
          vm.windowPLItem.isIn=1
          customPost('Lhc/bbsResort', vm.windowPLItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowPLCancel()
          })

        }
      })
    }

  }
}
</script>
